
import { Component, Vue } from "vue-property-decorator";
import ButtonAction from "@/components/buttons/Button.vue";
import { toast } from "@/store";
import { TYPE } from "@/store/modules/toast.module";
import LoginService from "@/services/login.service";

/**
 * Catch-all 404 page (router `path: "/*"`).
 * @remarks The login form fields/method below are dead — this template has no form, nothing calls
 * `login()`. Looks like leftover copy-paste from Login.vue.
 */
@Component({
  components: { ButtonAction },
})
export default class ErrorPage extends Vue {
  private username = "";
  private userpasswd = "";

  private backgroundImage = {
    backgroundImage: `url(${require("@/assets/images/photos/IMG_5378.jpg")})`,
  };

  private async login() {
    if (this.username && this.userpasswd) {
      if (await LoginService.login(this.username, this.userpasswd)) {
        this.$router.replace("/");
      } else {
        this.userpasswd = "";
      }
    } else {
      toast.createAndPushToast(
        "Veuillez saisir un nom d'utilisateur et un mot de passe",
        "",
        true,
        TYPE.INFO
      );
    }
  }
}
